module.exports = __webpack_public_path__ + "img/dbbg.0733f91c.png";